import { MRT_ColumnDef, MRT_RowData } from 'material-react-table';
import { EstadoComponente } from '@/shared/components/ui';
import { useFetchOrdenesCompras } from '@/shared/actions/erp';
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';

import { Button, Grid } from '@mui/material';
import { useMemo } from 'react';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { useState } from 'react';
import { SampleTable, } from '@/shared/components/ui';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { IUbicacionProducto } from '@/shared/interfaces/erp/inventario';
import { cellNotFilter, EstadosProcesoEnumChoice, formatDateWithTimeCell, TABLE_CONSTANTS_COLUMS } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import { OrdenesCompra } from '@/shared/interfaces/erp/compras/ordenes-compra.interface';
import ModalObservacionGeneral from '@/shared/components/ui/ModalObservacionesGeneral';


export default function SolicitudOrdenCompraRechazadosPagina() {
  useCheckPermissions(PermissionsEnum.api_view_ordencompra);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [details, setDetails] = useState<IUbicacionProducto[]>([]);
  const columns = useMemo<MRT_ColumnDef<OrdenesCompra>[]>(() => [
    {
      accessorKey: 'detalles',
      header: 'Producto',
      enableColumnFilter: false,
      enableSorting: false,
      enableColumnActions: false,
      size: 10,
      Cell: ({ row }) => {
        return (
          <Button
            variant='text'
            color='primary'
            startIcon={<VisibilityIcon />}
            onClick={() => onDetails(row.original)}
          >
            {'Ver'}
          </Button>

        );
      }
    },
    {
      accessorKey: 'numero_referencia',
      header: 'numero referencia',
    },
    {
      accessorKey: 'observaciones.observacionRevisor',
      header: 'observacion del Revisor',
      size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
      Cell: ({ row }) => (
        <ModalObservacionGeneral
          texto={row.original.observaciones?.observacionRevisor || 'N/A'}
          title='Observación del Revisor'
        />
      )
    },
    {
      accessorKey: 'plazo_pago',
      header: 'plazo pago',

    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_orden',
      header: 'fecha orden',
      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_orden')
    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_compra',
      header: 'fecha Compra',
      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_compra')

    },
    {
      ...cellNotFilter,
      accessorKey: 'fecha_entrega',
      header: 'fecha entrega',
      Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_entrega')


    },
    {
      accessorKey: 'forma_pago_data.nombre',
      header: 'forma_pago',
      Cell: ({ row }) => row.original?.forma_pago_data?.nombre || 'N/A'
    },
    {
      accessorKey: 'solicitud_ingreso',
      header: 'solicitud ingreso',

      Cell: ({ row }) => row.original?.solicitud_ingreso || 'N/A'
    },
    {
      accessorKey: 'proveedor_data.razon_social',
      header: 'proveedor',

    },
    {
      accessorKey: 'motivo_rechazo',
      header: 'Motivo Rechazo',
      Cell: ({ row }) => (
        <ModalObservacionGeneral
          texto={row.original?.motivo_rechazo || 'N/A'}
          title='Motivo'
        />
      )
    },
    {
      ...cellNotFilter,
      accessorKey: "estado_solicitud",
      header: "estado",
      size: 200,
      enableColumnActions: false,
      Cell: ({ row }) =>
        row.original.estado_orden != null ? (
          <EstadoComponente
            backgroundColor="red"
            texto={row.original.estado_orden || ""}
          />
        ) : null,
    },
  ], [])

  const onDetails = (e: MRT_RowData) => {

    setDetails(e.detalles || [])
    setIsModalOpen(true);
  };
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<IUbicacionProducto>[] = useMemo<
    MRT_ColumnDef<IUbicacionProducto>[]
  >(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.codigo || 'N/A',
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        Cell: ({ row }) => row.original?.producto_data?.descripcion || 'N/A',

      },
      {
        accessorKey: 'producto_data.unidad_medida',
        header: 'Medida',
        Cell: ({ row }) => row.original?.producto_data?.unidad_medida || 'N/A',
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo',
        Cell: ({ row }) => row.original?.producto_data?.modelo_producto || 'N/A',
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca',
        Cell: ({ row }) => row.original?.producto_data?.marca_producto || 'N/A'
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria',
      },

    ],
    []
  );

  const {
    //globalFilter,
    pagination,
    searchTerm,
    //onChangeFilter,
    setPagination,
    //cleanFilter,

  } = useTableFilter();

  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()
  const { pageIndex, pageSize } = pagination;
  //normalizamos 
  const normalizeFilters = (filters: Record<string, any>) => {
    const result: Record<string, any> = {}
    Object.entries(filters).forEach(([key, value]) => {
      const cleanKey = key.includes('.') ? key.split('.').pop()! : key
      const mappedKey = cleanKey === 'razon_social' ? 'proveedor_razon_social' : cleanKey
      result[mappedKey] = value
    })
    return result
  }

  const { isLoading, data: solicitudPedidosEnRechazadosRes, isRefetching, } = useFetchOrdenesCompras(
    {
      page: pageIndex + 1,
      numero_referencia: searchTerm,
      estado_orden: EstadosProcesoEnumChoice.CANCELADO,
      page_size: pageSize,
      ...normalizeFilters(filterObject)
      //...filterObject,
      //filterByState: false,

    });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<OrdenesCompra>
          columns={columns}
          data={solicitudPedidosEnRechazadosRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidosEnRechazadosRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          ///
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          // crud
          enableColumnActions={true}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn='first'
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Detalle Producto"
        onCloseIcon={() => setIsModalOpen(false)}
        minWidth="75%"
        contentNode={
          <>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {details.length > 0 && (
                  <SampleTable<IUbicacionProducto>
                    columns={columnsProductosDetallePedidosDb}
                    data={details}
                  />
                )}
              </Grid>
            </Grid>
          </>
        }
      />
    </Grid>
  );


}

